import { Box, Text } from '@primer/react';
import { ArrowRightIcon } from '@primer/octicons-react';
import heroVideo from '../assets/hero-video.webm';
import heroPoster from '../assets/posters/hero-video-poster.jpg';
import { CALENDLY_URL, trackContactClick } from '../utils/links';
import HeroBackground from './HeroBackground';
import WorkNav from './WorkNav';

function Hero() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: ['70vh', '70vh', '85vh'],
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <HeroBackground videoSrc={heroVideo} poster={heroPoster} />

      {/* scrim for text legibility over the video */}
      <Box sx={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.35)' }} />

      <Box
        sx={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingX: 4,
          paddingY: ['48px', '56px', '64px'],
        }}
      >
        <Box sx={{ textAlign: 'center', maxWidth: '900px' }}>
          <Text
            as="p"
            sx={{
              margin: 0,
              marginBottom: 3,
              fontSize: 1,
              fontWeight: 600,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            UX for Enterprise, FinTech, AI &amp; SaaS
          </Text>

          <Text
            as="h1"
            sx={{
              margin: 0,
              fontFamily: "'Fraunces', serif",
              fontWeight: 300,
              fontSize: ['2.25rem', '3.25rem', '4.5rem'],
              lineHeight: 1.2,
              color: '#f5f1ea',
            }}
          >
            Where complexity meets{' '}
            <Text as="span" sx={{ fontFamily: "'Fraunces', serif", fontStyle: 'italic' }}>
              clarity
            </Text>
            .
          </Text>

          <Box
            as="a"
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackContactClick}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 2,
              marginTop: 5,
              paddingX: 4,
              paddingY: 2,
              borderRadius: '6px',
              backgroundColor: '#1f883d',
              border: '1px solid rgba(27, 31, 36, 0.15)',
              color: '#ffffff',
              fontSize: 1,
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'background-color 0.15s ease',
              ':hover': { backgroundColor: '#1c8139' },
              ':active': { backgroundColor: '#197935' },
            }}
          >
            Schedule a Consultation
            <ArrowRightIcon size={16} />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          paddingX: 4,
          paddingBottom: ['24px', '32px', '48px'],
        }}
      >
        <WorkNav />
      </Box>
    </Box>
  );
}

export default Hero;
